<script setup>
import { RouterLink, useRoute } from 'vue-router'
import {
  BellAlertIcon,
  ArrowPathIcon,
  BuildingStorefrontIcon,
  CalendarDaysIcon,
  ChartBarSquareIcon,
  CircleStackIcon,
  CodeBracketSquareIcon,
  CpuChipIcon,
  DocumentTextIcon,
  LockClosedIcon,
  MapPinIcon,
  PaintBrushIcon,
  ShieldCheckIcon,
  TagIcon,
  TruckIcon,
  UserGroupIcon,
} from '@heroicons/vue/24/outline'
import { useI18n } from '../../i18n'

defineProps({ section: { type: Object, required: true }, divided: { type: Boolean, default: false } })
const emit = defineEmits(['navigate'])
const { t } = useI18n()
const route = useRoute()
const icons = {
  current: ChartBarSquareIcon,
  controllers: CpuChipIcon,
  transactions: CircleStackIcon,
  measurements: BuildingStorefrontIcon,
  deliveries: TruckIcon,
  alerts: BellAlertIcon,
  users: UserGroupIcon,
  roles: ShieldCheckIcon,
  stations: BuildingStorefrontIcon,
  api: CodeBracketSquareIcon,
  location: MapPinIcon,
  routes: ArrowPathIcon,
  document: DocumentTextIcon,
  price: TagIcon,
  calendar: CalendarDaysIcon,
  history: ArrowPathIcon,
  colors: PaintBrushIcon,
}
</script>

<template>
  <div v-if="divided" class="sidebar-divider"></div>
  <p v-if="section.labelKey" class="sidebar-section-label">{{ t(section.labelKey) }}</p>
  <template v-for="item in section.items" :key="item.routeName">
    <RouterLink v-if="!item.disabled" :to="item.to" :class="{ 'navigation-parent-active': (item.routeName === 'pts2-controllers' && String(route.name).startsWith('pts2-controller')) || (item.routeName === 'platform-stations' && route.name === 'platform-station-detail') }" @click="emit('navigate')">
      <component :is="icons[item.icon]" v-if="item.icon" aria-hidden="true" />
      <span>{{ t(item.labelKey) }}</span>
    </RouterLink>
    <span v-else class="sidebar-disabled-link" aria-disabled="true" :title="t('pts2SectionPlanned')">
      <component :is="icons[item.icon]" v-if="item.icon" aria-hidden="true" />
      <span>{{ t(item.labelKey) }}</span>
      <LockClosedIcon class="sidebar-planned-lock" aria-hidden="true" />
    </span>
  </template>
</template>

<style scoped>
.sidebar-disabled-link { color: #647b86 !important; }
.sidebar-disabled-link > .sidebar-planned-lock { width: 14px; height: 14px; margin-left: auto; }
</style>
